import React from "react"

/**
 * Props:
 * - title: string
 * - subheading: string
 * - steps: Array<{ title: string, content?: string }>
 */
const InfoStepsCard = ({ title, subheading, steps }) => {
  return (
    <div className="bg-[#2C2C36] rounded-xl p-8 w-full max-w-md mx-auto text-white">
      <h2 className="text-3xl font-semibold text-center mb-4">{title}</h2>
      <p className="text-lg text-center mb-8 text-gray-300">{subheading}</p>
      <ol className="space-y-6">
        {steps.map((step, idx) => (
          <li key={idx} className="flex items-start space-x-4">
            <span className="flex-shrink-0 w-10 h-10 rounded-full bg-[#43434F] flex items-center justify-center text-xl font-bold">
              {idx + 1}
            </span>
            <div>
              <span className="font-bold text-lg">{step.title}</span>
              {step.content && (
                <div className="text-gray-400 text-base mt-1">
                  {step.content}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}

export default InfoStepsCard
